import createInfoBarMessageViewState from './createInfoBarMessageViewState';
import getInfoBarMessageCreator from 'owa-info-bar/lib/utils/infoBarMessageCreatorsMap';
import {
    InfoBarMessageViewState,
    InfoBarMessageSource,
    InfoBarHostViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * These are custom infobars added through the owa-info-bar actions
 */
export default (
    viewState: InfoBarHostViewState,
    source: InfoBarMessageSource
): InfoBarMessageViewState[] => {
    const infoBarIds = viewState.infoBarIds;
    return infoBarIds.map(infoBarId => {
        const infoBarMessageCreator = getInfoBarMessageCreator(viewState, infoBarId);
        if (typeof infoBarMessageCreator === 'function') {
            return infoBarMessageCreator(viewState);
        } else {
            return createInfoBarMessageViewState(infoBarId, infoBarMessageCreator, source);
        }
    });
};
